import { createAction } from '@reduxjs/toolkit';

/**
 * "Signal" actions: intents the UI dispatches for the saga to act on. Kept out
 * of the slice's reducers: they trigger side effects, not state transitions (the
 * saga owns the resulting `save*` transitions).
 */

/** Send the invitation for the current draft (dispatched on Save). */
export const submitRequested = createAction('addAdministrator/submitRequested');
